import {Homonym} from '../../shared/models/homonym.model';

export enum HOMONYM_UI_BOX_TYPE {
  TYPE1 = 1,
  TYPE2,
  TYPE3,
  TYPE4,
}


export class HomonymUiBox {
  public type: HOMONYM_UI_BOX_TYPE;
  public listHomonym: Array<Homonym>;
  public visible: boolean;

  constructor(type: HOMONYM_UI_BOX_TYPE = HOMONYM_UI_BOX_TYPE.TYPE1, list: Array<Homonym> = new Array<Homonym>()) {
    this.type         = type;
    this.listHomonym  = list;
    this.visible      = false;

    // console.log('HomonymBox constructor', obj, this);
  }

}
